import { render, staticRenderFns } from "./ChangeCounselingCenterPrompt.vue?vue&type=template&id=6790732a&"
import script from "./ChangeCounselingCenterPrompt.vue?vue&type=script&lang=js&"
export * from "./ChangeCounselingCenterPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports